module.exports = __webpack_public_path__ + "static/NeueMontreal-Bold-0768cca1006da94fdd1043ac92cb3933.woff2";